/**
 * Returns true if string contains a valid URL that uses the http or https protocol.
 */
export const isValidHttpUrl = (str: string) => {
	if (typeof str !== "string") {
		return false;
	}

	try {
		const url = new URL(str);
		return url.protocol === "http:" || url.protocol === "https:";
	} catch {
		return false;
	}
};
